import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { selectAuth, updateProfile } from '../../../redux/slices/auth';
import { userService } from '../../../services/user.service';
import Input from '../../UI/Input/Input';
import Button from '../../UI/Button/Button';
import styles from './UserProfile.module.css';

function UserProfile() {
    const { t } = useTranslation('common');
    const { t: tValidation } = useTranslation('validation');
    const dispatch = useDispatch();
    const { user } = useSelector(selectAuth);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        middleName: '',
        phone: ''
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setFormData({
                firstName: user.first_name || '',
                lastName: user.last_name || '',
                middleName: user.middle_name || '',
                phone: user.phone || ''
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitized = name === 'phone' ? value.replace(/\D/g, '') : value;
        setFormData(prev => ({
            ...prev,
            [name]: sanitized
        }));
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            const response = await userService.updateProfile(formData);
            if (response.status === 'success') {
                toast.success(tValidation(response.message));
                dispatch(updateProfile(response.user));
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message;
            toast.error(errorMessage ? tValidation(errorMessage) : tValidation('something_went_wrong'));
        } finally {
            setLoading(false);
        }
    };

    if (!user) return null;

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{t('settings.profile.title')}</h2>

            <div className={styles.grid}>
                <div className={styles.field}>
                    <label>{t('settings.profile.lastName')}</label>
                    <Input
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        placeholder={t('settings.profile.lastName')}
                    />
                </div>
                <div className={styles.field}>
                    <label>{t('settings.profile.firstName')}</label>
                    <Input
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        placeholder={t('settings.profile.firstName')}
                    />
                </div>
                <div className={styles.field}>
                    <label>{t('settings.profile.middleName')}</label>
                    <Input
                        name="middleName"
                        value={formData.middleName}
                        onChange={handleChange}
                        placeholder={t('settings.profile.middleName')}
                    />
                </div>
                <div className={styles.field}>
                    <label>{t('settings.profile.phone')}</label>
                    <Input
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder={t('settings.profile.phone')}
                    />
                </div>

                <div className={styles.field}>
                    <label>{t('settings.profile.email')}</label>
                    <Input
                        value={user.email}
                        disabled
                    />
                </div>
            </div>

            <div className={styles.actions}>
                <Button
                    onClick={handleSave}
                    disabled={loading}
                    variant="primary"
                >
                    {t('settings.profile.save')}
                </Button>
            </div>
        </div>
    );
}

export default UserProfile;
